import { Platform } from "react-native";

export const FOOTER_HEIGHT = 60;
export const FULL_WIDTH = '100%', FULL_HEIGHT ='100%';
export const MODAL_MAX_WIDTH = Platform.OS === 'web' ? 500 : FULL_WIDTH;
export const ARTICLE_HEIGHT = 200;
export const HEADER_HEIGHT = 55;
export const CIRCLE_SIZE_SM = 50;
export const CIRCLE_SIZE_MD = 60;